const STORAGE_KEY = 'hd-theme-mode';
const root = document.documentElement;

function applyMode(mode) {
  const normalized = mode === 'day' ? 'day' : 'night';
  const previousMode = root.dataset.hdThemeMode;
  root.dataset.hdThemeMode = normalized;
  document.querySelectorAll('[data-hd-theme-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', normalized === 'day' ? 'true' : 'false');
    button.dataset.mode = normalized;
  });

  if (previousMode !== normalized) {
    document.dispatchEvent(
      new CustomEvent('hd:theme-mode-change', {
        detail: { mode: normalized, previousMode },
      })
    );
  }

  window.requestAnimationFrame(() => {
    window.HDProductCardMediaGuard?.scheduleRefresh?.();
  });
}

function initThemeMode() {
  const savedMode = window.localStorage.getItem(STORAGE_KEY) || 'night';
  applyMode(savedMode);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hd-theme-toggle]');
    if (!button) return;

    const nextMode = root.dataset.hdThemeMode === 'day' ? 'night' : 'day';
    window.localStorage.setItem(STORAGE_KEY, nextMode);
    applyMode(nextMode);
  });
}

initThemeMode();
